import { render, staticRenderFns } from "./SubjectRelationsInfo.vue?vue&type=template&id=02225853&"
import script from "./SubjectRelationsInfo.vue?vue&type=script&lang=js&"
export * from "./SubjectRelationsInfo.vue?vue&type=script&lang=js&"
import style0 from "./SubjectRelationsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VCard,VCardSubtitle,VCardText,VCardTitle,VIcon,VListItem,VListItemContent,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02225853')) {
      api.createRecord('02225853', component.options)
    } else {
      api.reload('02225853', component.options)
    }
    module.hot.accept("./SubjectRelationsInfo.vue?vue&type=template&id=02225853&", function () {
      api.rerender('02225853', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VisitorScanPage/components/SubjectRelationsInfo.vue"
export default component.exports